import * as React from 'react';

import { PhrasesSelectorWizardContainer } from '../../containers/PhrasesSelectorWizardContainer/PhrasesSelectorWizardContainer';
import { Bem } from '../../service/Bem/Bem';
import { ClientInfo } from '../../typings/common';
import { PhrasesSelectorWizardId } from '../../typings/phrases';
import { Inspector } from '../Inspector/Inspector';

import './PhrasesSelectorInspector.css';

export interface PhrasesSelectorInspectorProps {
    wizardId: PhrasesSelectorWizardId;
    clientInfo: ClientInfo;
    onClosePhrasesSelectorWizard: () => void;
    onSubmitPhrasesSelectorWizard: () => void;
    isVisible: boolean;
    isMinusWordsListEnabled: boolean;
}

const blockClass = 'phrases-selector-inspector';

export class PhrasesSelectorInspector extends React.Component<
    PhrasesSelectorInspectorProps
> {
    render() {
        const {
            wizardId,
            isVisible,
            onClosePhrasesSelectorWizard,
            onSubmitPhrasesSelectorWizard,
            isMinusWordsListEnabled
        } = this.props;

        return (
            <Inspector
                visible={isVisible}
                hasClose={true}
                progress={false}
                cls={blockClass}
                onClose={onClosePhrasesSelectorWizard}
                onEsc={onClosePhrasesSelectorWizard}
                onCancel={onClosePhrasesSelectorWizard}
                hasOverlay={true}
            >
                <PhrasesSelectorWizardContainer
                    cls={Bem.cls(blockClass, 'wizard')}
                    wizardId={wizardId}
                    isMinusWordsListEnabled={isMinusWordsListEnabled}
                    onSubmit={onSubmitPhrasesSelectorWizard}
                />
            </Inspector>
        );
    }
}
